import { CSSObject } from "@emotion/react";

export const titleShimmerCss = {
  root: {
    width: "618px",
    height: "44px",
    borderRadius: "20px",
    margin: "44px 80px 20px 80px",
  },
};

export const rowContainerCss: CSSObject = {
  display: "grid",
  gap: "36px",
};

export const rowHeadingShimmerCss = {
  root: {
    width: "375px",
    height: "32px",
    borderRadius: "20px",
  },
};

export const loadingCardShimmerCss = {
  root: {
    borderRadius: "16px",
    height: "452px",
  },
};
